__turbopack_context__.v({
  "className": "montserrat_eb80f4db-module__St866q__className",
});
